/** Coalesce snapshot bursts and suspend background repainting, not subscriptions. */
export function createRealtimeRenderScheduler(input: {
  render: () => void;
  blocked: () => boolean;
  requestFrame: (callback: () => void) => number;
  cancelFrame: (id: number) => void;
}) {
  let pending = false;
  let frame: number | undefined;
  let disposed = false;
  const cancel = (): void => {
    if (frame !== undefined) input.cancelFrame(frame);
    frame = undefined;
    pending = false;
  };
  const resume = (): void => {
    if (disposed || !pending || frame !== undefined || input.blocked()) return;
    frame = input.requestFrame(() => {
      frame = undefined;
      if (disposed || input.blocked()) return;
      pending = false;
      input.render();
    });
  };
  return {
    request: () => {
      if (disposed) return;
      pending = true;
      resume();
    },
    resume,
    cancel,
    dispose: () => {
      disposed = true;
      cancel();
    },
  };
}
